<section class="contact">	
	<img loading="lazy" src="../../../../assets/images/fones.jpg">
</section>